const checkTypes = {
    IN: "IN",
    OUT: "OUT",
};

export default checkTypes;